import React, { useState, useRef, useEffect, use, forwardRef } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import analtics from "../assets/Dashboard/analtics.png";
import vechile from "../assets/Dashboard/vehicle.png";
import active from "../assets/Dashboard/active.png";
import rent from "../assets/Dashboard/rent.png";
import totalVehIC from "../assets/svg/total_veh_ic.svg";
import rentIc from "../assets/svg/rented_ic.svg";
import activeIc from "../assets/svg/active_ic.svg";
import underMaintIC from "../assets/svg/under_maint_ic.svg";
import outSerivceIC from "../assets/svg/out_o_service.svg";
import search from "../assets/Vehicles/search.png";
import markerIcon from "../assets/png/map-lorry-png.png";
import service from "../assets/Dashboard/maintenance.png";
import user from "../assets/Dashboard/user.png";
import arrow from "../assets/Dashboard/redarrow.png";
import profileIc from "../assets/png/profile-ic.png";
import { Calendar, Download, ChevronDown } from "lucide-react";
import { Doughnut } from "react-chartjs-2";
import "./Vehicles/Vehicle_list/List.css";
import { Bar } from "react-chartjs-2";
import YearSelector from "./common/YearSelector";

import { Chart as ChartJS, LineElement, CategoryScale, LinearScale, PointElement, Tooltip, Filler, ArcElement, BarElement } from "chart.js";

// pdf
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { getCountDetApi, getFuelCostApi, getKmCostApi, getLiveViewApi, getOtherCostApi, getRecentCommentApi, getServiceCostApi } from "./dashboard_api";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import polyline from "@mapbox/polyline";
export const Dashboard = () => {
  const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAP_KEY;

  const [center, setCenter] = useState({
    lat: 13.0843,
    lng: 80.2705,
  });
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: googleMapsApiKey,
  });
  const [marker, setMarker] = useState(null);
  const [overallDateFilter, setOverallDateFilter] = useState();
  const [vehAssig, setVehAssig] = useState(new Date());
  const [monthServiceDateReminder, setServiceDateReminder] = useState(new Date());
  const [ppenDateIssue, setOpenDateIssue] = useState(new Date());

  const [yearOtherCost, setYearOtherCost] = useState(new Date().getFullYear().toString());
  const [yearServiceCost, setYearServiceCost] = useState(new Date().getFullYear().toString());
  const [yearPerKmCost, setYearPerKmCost] = useState(new Date().getFullYear().toString());
  const [yearFuelCost, setYearFuelCost] = useState(new Date().getFullYear().toString());

  useEffect(() => {
    getCountDetails();
    getRecentComments();
    getLiveView();
  }, []);

  useEffect(() => {
    getOtherCost();
  }, [yearOtherCost]);
  useEffect(() => {
    getServiceCost();
  }, [yearServiceCost]);
  useEffect(() => {
    getCostPerKm();
  }, [yearPerKmCost]);
  useEffect(() => {
    getFuelCost();
  }, [yearFuelCost]);
  //Api Variable
  const [countDetails, setCountDetails] = useState({});
  const [serviceReminder, setServiceReminder] = useState({});
  const [issueDetails, setIssueDetails] = useState({});
  const [assignmentDet, setAssignmentDet] = useState({});
  const [recentComments, setRecentComments] = useState({});
  const [fuelChartList, setFuelChartList] = useState([]);
  const [fuelChartDetails, setFuelChartDetails] = useState({});
  const [costChartList, setCostChartList] = useState([]);
  const [costChartDetails, setCostChartDetails] = useState({});
  const [serviceList, setServiceList] = useState([]);
  const [serviceDetails, setServiceDetails] = useState({});
  const [otherList, setOtherList] = useState([]);
  const [otherDetails, setOtherDetails] = useState({});
  //Api

  const getCountDetails = async () => {
    try {
      const response = await getCountDetApi();
      console.log("repsonse", response.data);
      if (response.data.success === true) {
        var countDetails = response.data.data;
        setCountDetails(countDetails.count || {});
        setServiceReminder(countDetails.service_reminder || {});
        setIssueDetails(countDetails.issue || {});
        setAssignmentDet(countDetails.assignments || {});
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getRecentComments = async () => {
    try {
      const response = await getRecentCommentApi();
      console.log("repsonse", response.data);
      if (response.data.success === true) {
        var recentDetails = response.data.comments;
        setRecentComments(recentDetails || {});
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getLiveView = async () => {
    try {
      const response = await getLiveViewApi();
      console.log("response_Live_view", response.data);

      if (response.data.success === true) {
        console.log("parsedResponse1", response.data.data);
        const responseList = response.data.data;

        let allMarkers = []; // Collect markers from all responses

        responseList.forEach((item, index) => {
          try {
            const parsedResponse = JSON.parse(item.response);
            console.log(`parsedResponse ${index}`, parsedResponse);

            const encodedPoints = parsedResponse.points || parsedResponse.overviewPolyline;

            if (encodedPoints) {
              const decoded = polyline.decode(encodedPoints);

              if (decoded.length > 0) {
                const [lat, lng] = decoded[0]; // Take first coordinate only
                const point = {
                  id: `${index}-0`, // Unique ID
                  position: { lat, lng },
                };
                allMarkers.push(point);
                console.log("point added:", point);
              }
            }
          } catch (parseError) {
            console.error("Error parsing response at index", index, parseError);
          }
        });

        console.log("allMarkers final:", allMarkers);

        setMarker(allMarkers);

        if (allMarkers.length > 0) {
          setCenter(allMarkers[0].position); // Center map on first marker
        }
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    }
  };

  const getFuelCost = async () => {
    const bodyData = { period: yearFuelCost };
    try {
      const response = await getFuelCostApi(bodyData);
      console.log("repsonse", response.data);
      if (response.data.success === true) {
        var recentDetails = response.data.data;
        setFuelChartDetails(recentDetails ?? {});
        setFuelChartList(recentDetails.chart || []);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getCostPerKm = async () => {
    const bodyData = { period: yearPerKmCost };
    try {
      const response = await getKmCostApi(bodyData);
      console.log("repsonse", response.data);
      if (response.data.success === true) {
        var recentDetails = response.data.data;
        console.log("recentDetails Changes...", recentDetails.chart);
        setCostChartList(recentDetails.chart ?? []);
        setCostChartDetails(recentDetails || []);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getServiceCost = async () => {
    const bodyData = { period: yearServiceCost };
    try {
      const response = await getServiceCostApi(bodyData);
      console.log("repsonse", response.data);
      if (response.data.success === true) {
        var recentDetails = response.data.data;
        console.log("recentDetails Changes...", recentDetails.chart);
        setServiceList(recentDetails.chart ?? []);
        setServiceDetails(recentDetails || []);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getOtherCost = async () => {
    const bodyData = { period: yearOtherCost };

    try {
      const response = await getOtherCostApi(bodyData);
      console.log("repsonse", response.data);
      if (response.data.success === true) {
        var recentDetails = response.data.data;
        console.log("recentDetails Changes...", recentDetails.chart);
        setOtherList(recentDetails.chart ?? []);
        setOtherDetails(recentDetails || []);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, Tooltip, Filler, ArcElement, BarElement);

  const doughnutOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
    },
  };
  // Issue chart

  // vertical bar chart
  const labels = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const options = {
    responsive: true,
    plugins: {
      tooltip: {
        callbacks: {
          label: (context) => `${context.raw}`,
        },
        backgroundColor: "#333",
        titleColor: "#fff",
        bodyColor: "#fff",
        displayColors: false,
      },
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { color: "#000" },
      },
      y: {
        display: false,
      },
    },
    onHover: (event, chartElement) => {
      event.native.target.style.cursor = chartElement.length ? "pointer" : "default";
      event.chart.update();
    },
    onLeave: (event) => {
      event.chart.update();
    },
  };

  return (
    <>
      <div className="bg-half-white p-0">
        <div className="row w-80 p-3 flex-wrap gap-1">
          <div className="col">
            <div className="bg-white rounded-4 p-3">
              <div className="d-flex gap-3 align-items-center">
                <div
                  style={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "100px",
                    backgroundColor: "#F7EDFF",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img src={totalVehIC} alt="vehicle" />
                </div>
                <div>
                  <p
                    className="m-0 fs-13 fw-400"
                    style={{
                      color: "#8790A1",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "120px", // set your desired width
                    }}
                  >
                    Total vehicles
                  </p>
                  <p className="m-0 fs-22 fw-600" style={{ color: "#172B4D" }}>
                    {countDetails.total ?? 0}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="bg-white rounded-4 p-3">
              <div className="d-flex gap-2 align-items-center">
                <div
                  style={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "100px",
                    backgroundColor: "#F7EDFF",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img src={activeIc} alt="vehicle" />
                </div>
                <div>
                  <p className="m-0 fs-13 fw-400" style={{ color: "#8790A1" }}>
                    Active
                  </p>
                  <p className="m-0 fs-22 fw-600" style={{ color: "#172B4D" }}>
                    {countDetails.active ?? 0}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="bg-white rounded-4 p-3">
              <div className="d-flex gap-3 align-items-center">
                <div
                  style={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "100px",
                    backgroundColor: "#F7EDFF",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img src={rentIc} alt="vehicle" />
                </div>
                <div>
                  <p className="m-0 fs-13 fw-400" style={{ color: "#8790A1" }}>
                    Rented
                  </p>
                  <p className="m-0 fs-22 fw-600" style={{ color: "#172B4D" }}>
                    {countDetails.rented ?? 0}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="bg-white rounded-4 p-3">
              <div className="d-flex gap-3 align-items-center">
                <div
                  style={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "100px",
                    backgroundColor: "#F7EDFF",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img src={underMaintIC} alt="under" />
                </div>
                <div>
                  <p
                    className="m-0 fs-13 fw-400"
                    style={{
                      color: "#8790A1",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      // maxWidth: "120px", // set your desired width
                    }}
                  >
                    Under maintenance
                  </p>
                  <p className="m-0 fs-22 fw-600" style={{ color: "#172B4D" }}>
                    {countDetails.under_mainten ?? 0}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col pe-0">
            <div className="bg-white rounded-4 p-3">
              <div className="d-flex gap-3 align-items-center">
                <div
                  style={{
                    width: "48px",
                    height: "48px",
                    borderRadius: "100px",
                    backgroundColor: "#F7EDFF",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img src={outSerivceIC} alt="out" />
                </div>
                <div>
                  <p
                    className="m-0 fs-13 fw-400"
                    style={{
                      color: "#8790A1",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      // maxWidth: "100px", // set your desired width
                    }}
                  >
                    Out of service
                  </p>
                  <p className="m-0 fs-22 fw-600" style={{ color: "#172B4D" }}>
                    {countDetails.out_of_ser ?? 0}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mx-1">
          <div className="col-xl-4">
            <div
              style={{
                cursor: "pointer",
              }}
            >
              <div className="bg-white rounded-4 p-3">
                <div className="d-flex justify-content-between">
                  <p className="m-0 fs-16 fw-700" style={{ color: "#172B4D" }}>
                    Service Reminder
                  </p>
                  {/* <DatePicker
                      selected={monthServiceDateReminder}
                      onChange={(date) => setServiceDateReminder(date)}
                      dateFormat="MMMM, yyyy"
                      showMonthYearPicker
                      popperPlacement="bottom-start"
                      customInput={
                        <button className="d-flex align-items-center gap-2 border-0 bg-transparent text-purple">
                          <Calendar size={16} color="#7157C2" />
                          {monthServiceDateReminder.toLocaleString("default", {
                            month: "long",
                            year: "numeric",
                          })}
                        </button>
                      }
                    /> */}
                </div>
                <div className="d-flex mt-3">
                  <div className="col-7">
                    <div className="doughnut text-center">
                      <Doughnut
                        className="p-3"
                        data={{
                          labels: ["Completed", "Remaining"],
                          datasets: [
                            {
                              data: [serviceReminder.over_due, serviceReminder.due_soon],
                              backgroundColor: ["#7157C2", "#FF6594"],
                              cutout: "80%",
                              borderRadius: 2,
                            },
                          ],
                        }}
                        options={doughnutOptions}
                      />
                      {/* Text in Center */}
                      <div className="centerText fs-20 text-center">
                        <span className=" fw-bold">
                          <span style={{ color: "#172B4D" }}>{serviceReminder.over_due + serviceReminder.due_soon}</span>
                        </span>
                        <br /> <span style={{ color: "#8790A1" }}> Total</span>
                      </div>
                      <p className="m-0 mt-3 fs-15 fw-500" style={{ color: "#8790A1" }}>
                        {serviceReminder.diff_percent ?? 0} % of reminders are overdue issues.
                      </p>
                    </div>
                  </div>
                  <div className="col d-flex flex-column justify-content-center gap-3">
                    <div className="p-3 rounded-4 " style={{ border: "0.8px solid #EBEBEB" }}>
                      <p className="m-0 fs-13 fw-400" style={{ color: "#7157C2" }}>
                        Overdue
                      </p>
                      <p className="m-0 fs-20 fw-500" style={{ color: "#172B4D" }}>
                        {serviceReminder.over_due ?? 0}
                      </p>
                    </div>
                    <div className="p-3 rounded-4" style={{ border: "0.8px solid #EBEBEB" }}>
                      <p className="m-0 fs-13 fw-400" style={{ color: "#FF6594" }}>
                        Due soon
                      </p>
                      <p className="m-0 fs-20 fw-500" style={{ color: "#172B4D" }}>
                        {serviceReminder.due_soon ?? 0}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-4 mt-3 mt-xl-0">
            <div
              style={{
                cursor: "pointer",
              }}
            >
              <div className="bg-white rounded-4 p-3">
                <div className="d-flex justify-content-between">
                  <p className="m-0 fs-16 fw-700" style={{ color: "#172B4D" }}>
                    Open Issues
                  </p>
                </div>
                <div className="d-flex mt-3">
                  <div className="col-7">
                    <div className="doughnut text-center">
                      <Doughnut
                        className="p-2"
                        data={{
                          labels: ["Completed", "Remaining"],
                          datasets: [
                            {
                              data: [issueDetails.open, issueDetails.closed],
                              backgroundColor: ["#7157C2", "#FF6594"],
                              cutout: "80%",
                              borderRadius: 2,
                            },
                          ],
                        }}
                        options={doughnutOptions}
                      />
                      {/* Text in Center */}
                      <div className="centerText fs-20 text-center">
                        <span className=" fw-bold">
                          <span style={{ color: "#172B4D" }}>{issueDetails.closed + issueDetails.open}</span>
                        </span>
                        <br /> <span style={{ color: "#8790A1" }}> Total</span>
                      </div>
                      <p className="m-0 mt-3 fs-15 fw-500" style={{ color: "#8790A1" }}>
                        {issueDetails.diff_percent}% of issues are open issues.
                      </p>
                    </div>
                  </div>
                  <div className="col d-flex flex-column justify-content-center gap-3">
                    <div className="p-3 rounded-4" style={{ border: "0.8px solid #EBEBEB" }}>
                      <p className="m-0 fs-13 fw-400" style={{ color: "#7157C2" }}>
                        Open
                      </p>
                      <p className="m-0 fs-20 fw-500" style={{ color: "#172B4D" }}>
                        {issueDetails.open}
                      </p>
                    </div>
                    <div className="p-3 rounded-4" style={{ border: "0.8px solid #EBEBEB" }}>
                      <p className="m-0 fs-13 fw-400" style={{ color: "#FF6594" }}>
                        Closed
                      </p>
                      <p className="m-0 fs-20 fw-500" style={{ color: "#172B4D" }}>
                        {issueDetails.closed}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-4 mt-3 mt-xl-0 pe-0">
            <div
              style={{
                cursor: "pointer",
              }}
            >
              <div className="bg-white rounded-4 p-3">
                <div className="d-flex justify-content-between">
                  <p className="m-0 fs-16 fw-700" style={{ color: "#172B4D" }}>
                    Vehicle Assignments
                  </p>
                </div>
                <div className="d-flex mt-3">
                  <div className="col-7">
                    <div className="doughnut text-center">
                      <Doughnut
                        className="p-2"
                        data={{
                          labels: ["Completed", "Remaining"],
                          datasets: [
                            {
                              data: [assignmentDet.assigned, assignmentDet.unassigned],
                              backgroundColor: ["#7157C2", "#FF6594"],
                              cutout: "80%",
                              borderRadius: 2,
                            },
                          ],
                        }}
                        options={doughnutOptions}
                      />
                      {/* Text in Center */}
                      <div className="centerText fs-20 text-center">
                        <span className=" fw-bold">
                          <span style={{ color: "#172B4D" }}>{assignmentDet.assigned + assignmentDet.unassigned}</span>
                        </span>
                        <br /> <span style={{ color: "#8790A1" }}> Total</span>
                      </div>
                      <p className="m-0 mt-3 fs-15 fw-500" style={{ color: "#8790A1" }}>
                        {assignmentDet.diff_percent}% of vehicle are assigned to drivers.
                      </p>
                    </div>
                  </div>
                  <div className="col d-flex flex-column justify-content-center gap-3">
                    <div className="p-3 rounded-4" style={{ border: "0.8px solid #EBEBEB" }}>
                      <p className="m-0 fs-13 fw-400" style={{ color: "#7157C2" }}>
                        Assigned
                      </p>
                      <p className="m-0 fs-20 fw-500" style={{ color: "#172B4D" }}>
                        {assignmentDet.assigned ?? 0}
                      </p>
                    </div>
                    <div className="p-3 rounded-4" style={{ border: "0.8px solid #EBEBEB" }}>
                      <p className="m-0 fs-13 fw-400" style={{ color: "#FF6594" }}>
                        Unassigned
                      </p>
                      <p className="m-0 fs-20 fw-500" style={{ color: "#172B4D" }}>
                        {assignmentDet.unassigned ?? 0}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mx-1 mt-2">
          <div className="col-xl-8">
            <div className="bg-white rounded-4 p-3">
              <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
                <p className="m-0 fs-17 fw-600">Live vehicle location</p>
                {/* <div className="search-wrapper d-flex align-items-center gap-2 bg-white rounded-3 px-3 py-2">
                    <img src={search} alt="search" />
                    <input
                      type="text"
                      placeholder="Search"
                      className="border-0 outline-0 rounded-3"
                    />
                  </div> */}
              </div>
              {isLoaded && (
                <GoogleMap mapContainerStyle={{ width: "100%", height: 400 }} center={center} zoom={14}>
                  {marker &&
                    marker.length > 0 &&
                    marker.map((m) => (
                      <Marker
                        key={m.id}
                        position={m.position}
                        icon={{
                          url: markerIcon,
                          scaledSize: new window.google.maps.Size(50, 50),
                        }}
                      />
                    ))}
                </GoogleMap>
              )}
            </div>
          </div>
          <div className="col-xl-4 mt-3 mt-xl-0 pe-0">
            <div
              className="bg-white rounded-4 p-3 overflow-y-auto hide-scroll h-100"
              // style={{ height: "400px" }}
            >
              {/* Comments List */}
              <div>
                <h6 className="fw-700 fs-16 mb-3">Recent comments - {recentComments?.length || 0}</h6>

                {recentComments && recentComments.length > 0 ? (
                  recentComments.map((comment) => (
                    <div
                      key={comment.id || comment.name} // Prefer unique id; fallback to name
                      className="d-flex align-items-start justify-content-between py-3 border-bottom"
                      style={{ fontSize: "14px" }}
                    >
                      <div className="d-flex">
                        <div
                          className="rounded-circle bg-light d-flex align-items-center justify-content-center me-3"
                          style={{
                            width: "40px",
                            height: "40px",
                            overflow: "hidden",
                          }}
                        >
                          <img
                            src={comment.image || profileIc}
                            alt={comment.name || "User image"}
                            className="img-fluid"
                            style={{
                              objectFit: "cover",
                              width: "100%",
                              height: "100%",
                            }}
                            // onError={(e) => (e.target.src = profileIc)}
                          />
                        </div>
                        <div>
                          <div className="fw-500 fs-13">{comment.name}</div>
                          <div className="text-muted fw-400 fs-12">{comment.comment}</div>
                        </div>
                      </div>
                      <p className="text-muted fw-500 fs-11">{comment.time}</p>
                    </div>
                  ))
                ) : (
                  <div className="text-center text-muted py-3">No comments found.</div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="row mx-1 mt-3">
          <div className="col-xl-6">
            <div className="bg-white rounded-4 p-3">
              <div className="d-flex justify-content-between">
                <div
                  style={{
                    fontWeight: 700,
                    fontSize: "16px",
                    color: "#172B4D",
                  }}
                >
                  Fuel Cost
                </div>
                <YearSelector selectedYear={yearFuelCost} onYearChange={setYearFuelCost} />
              </div>
              <p className="m-0 fs-32 fw-600 pagination-color">{fuelChartDetails.diff_percent} %</p>
              <p className="m-0 fs-12 fw-400" style={{ color: "#626F86" }}>
                {fuelChartDetails.is_decreased ? "Decreased" : "Increased"} from last month
              </p>
              <div className="bg-grey mt-3 px-3 py-2 d-inline-flex align-items-center w-auto gap-2 rounded-pill mb-2">
                <div className="red-bar rounded-pill"></div>
                <p className="m-0">{fuelChartDetails.is_decreased ? "Decreased" : "Increased"} amount</p>

                <div className="bg-white px-3 py-1 gap-1 d-flex align-items-center w-auto rounded-pill ">
                  <img
                    src={arrow}
                    alt="arrow"
                    style={{
                      transform: fuelChartDetails.is_decreased ? "rotate(180deg)" : "",
                      filter: fuelChartDetails.is_decreased ? "" : "invert(40%) sepia(100%) saturate(300%) hue-rotate(90deg) brightness(100%) contrast(90%)",
                    }}
                  />
                  <p className="m-0 ">₹ {fuelChartDetails.diff_amount}</p>
                </div>
              </div>
              {fuelChartList && fuelChartList.length > 0 ? (
                <Bar
                  data={{
                    labels: fuelChartList.map((item) => item.period),
                    datasets: [
                      {
                        data: fuelChartList.map((item) => item.total),
                        backgroundColor: (context) => {
                          const index = context.dataIndex;
                          const chart = context.chart;
                          const activeElements = chart.tooltip?.getActiveElements();

                          if (activeElements && activeElements.length > 0) {
                            const hoveredIndex = activeElements[0].index;
                            return hoveredIndex === index ? "#7157C2" : "#E6E1FF";
                          }
                          return "#E6E1FF";
                        },
                        borderRadius: 8,
                        maxBarThickness: 50,
                      },
                    ],
                  }}
                  options={options}
                />
              ) : (
                <div className="text-center text-muted py-3">No data available.</div>
              )}
            </div>
          </div>
          <div className="col-xl-6 pe-0 mt-3 mt-xl-0">
            <div className="bg-white rounded-4 p-3">
              <div className="d-flex justify-content-between align-items-center">
                <p className="m-0 fs-16 fw-700" style={{ color: "#172B4D" }}>
                  Vehicle Km History
                </p>
                <YearSelector selectedYear={yearPerKmCost} onYearChange={setYearPerKmCost} />
              </div>
              <p className="m-0 fs-32 fw-600 pagination-color"> {costChartDetails.diff_percent} %</p>
              <p className="m-0 fs-12 fw-400" style={{ color: "#626F86" }}>
                {costChartDetails.is_decreased ? "Decreased" : "Increased"} from last month
              </p>
              <div className="bg-grey mt-3 px-3 py-2 d-inline-flex align-items-center w-auto gap-2 rounded-pill mb-2">
                <div className="red-bar rounded-pill"></div>
                <p className="m-0"> {costChartDetails.is_decreased ? "Decreased" : "Increased"} amount</p>
                <div className="bg-white px-3 py-1 gap-1 d-flex align-items-center w-auto rounded-pill">
                  <img
                    src={arrow}
                    alt="arrow"
                    style={{
                      transform: costChartDetails.is_decreased ? "rotate(180deg)" : "",
                      filter: costChartDetails.is_decreased ? "" : "invert(40%) sepia(100%) saturate(300%) hue-rotate(90deg) brightness(100%) contrast(90%)",
                    }}
                  />
                  <p className="m-0">₹ {costChartDetails.diff_amount}</p>
                </div>
              </div>
              {costChartList && costChartList.length > 0 ? (
                <Bar
                  data={{
                    labels: costChartList.map((item) => item.period),
                    datasets: [
                      {
                        data: costChartList.map((item) => item.total),
                        backgroundColor: (context) => {
                          const index = context.dataIndex;
                          const chart = context.chart;
                          const activeElements = chart.tooltip?.getActiveElements();

                          if (activeElements && activeElements.length > 0) {
                            const hoveredIndex = activeElements[0].index;
                            return hoveredIndex === index ? "#7157C2" : "#E6E1FF";
                          }
                          return "#E6E1FF";
                        },
                        borderRadius: 8,
                        maxBarThickness: 50,
                      },
                    ],
                  }}
                  options={options}
                />
              ) : (
                <div className="text-center text-muted py-3">No data available.</div>
              )}
            </div>
          </div>
          <div className="col-xl-6 mt-3">
            <div className="bg-white rounded-4 p-3">
              <div className="d-flex justify-content-between align-items-center">
                <p className="m-0 fs-16 fw-700" style={{ color: "#172B4D" }}>
                  Service Cost
                </p>
                <YearSelector selectedYear={yearServiceCost} onYearChange={setYearServiceCost} />
              </div>
              <p className="m-0 fs-32 fw-600 pagination-color"> {serviceDetails.diff_percent} %</p>
              <p className="m-0 fs-12 fw-400" style={{ color: "#626F86" }}>
                {serviceDetails.is_decreased ? "Decreased" : "Increased"} from last month
              </p>
              <div className="bg-grey mt-3 px-3 py-2 d-inline-flex align-items-center w-auto gap-2 rounded-pill mb-2">
                <div className="red-bar rounded-pill"></div>
                <p className="m-0"> {serviceDetails.is_decreased ? "Decreased" : "Increased"} amount</p>
                <div className="bg-white px-3 py-1 gap-1 d-flex align-items-center w-auto rounded-pill">
                  <img
                    src={arrow}
                    alt="arrow"
                    style={{
                      transform: serviceDetails.is_decreased ? "rotate(180deg)" : "",
                      filter: serviceDetails.is_decreased ? "" : "invert(40%) sepia(100%) saturate(300%) hue-rotate(90deg) brightness(100%) contrast(90%)",
                    }}
                  />
                  <p className="m-0">₹ {serviceDetails.diff_amount}</p>
                </div>
              </div>
              {serviceList && serviceList.length > 0 ? (
                <Bar
                  data={{
                    labels: serviceList.map((item) => item.period),
                    datasets: [
                      {
                        data: serviceList.map((item) => item.total),
                        backgroundColor: (context) => {
                          const index = context.dataIndex;
                          const chart = context.chart;
                          const activeElements = chart.tooltip?.getActiveElements();

                          if (activeElements && activeElements.length > 0) {
                            const hoveredIndex = activeElements[0].index;
                            return hoveredIndex === index ? "#7157C2" : "#E6E1FF";
                          }
                          return "#E6E1FF";
                        },
                        borderRadius: 8,
                        maxBarThickness: 50,
                      },
                    ],
                  }}
                  options={options}
                />
              ) : (
                <div className="text-center text-muted py-3">No data available.</div>
              )}
            </div>
          </div>
          <div className="col-xl-6 pe-0 mt-3">
            <div className="bg-white rounded-4 p-3">
              <div className="d-flex justify-content-between align-items-center">
                <p className="m-0 fs-16 fw-700" style={{ color: "#172B4D" }}>
                  Other Cost
                </p>
                <YearSelector selectedYear={yearOtherCost} onYearChange={setYearOtherCost} />
              </div>
              <p className="m-0 fs-32 fw-600 pagination-color"> {otherDetails.diff_percent} %</p>
              <p className="m-0 fs-12 fw-400" style={{ color: "#626F86" }}>
                {otherDetails.is_decreased ? "Decreased" : "Increased"} from last month
              </p>
              <div className="bg-grey mt-3 px-3 py-2 d-inline-flex align-items-center w-auto gap-2 rounded-pill mb-2">
                <div className="red-bar rounded-pill"></div>
                <p className="m-0"> {otherDetails.is_decreased ? "Decreased" : "Increased"} amount</p>
                <div className="bg-white px-3 py-1 gap-1 d-flex align-items-center w-auto rounded-pill">
                  <img
                    src={arrow}
                    alt="arrow"
                    style={{
                      transform: otherDetails.is_decreased ? "rotate(180deg)" : "",
                      filter: otherDetails.is_decreased ? "" : "invert(40%) sepia(100%) saturate(300%) hue-rotate(90deg) brightness(100%) contrast(90%)",
                    }}
                  />
                  <p className="m-0">₹ {otherDetails.diff_amount}</p>
                </div>
              </div>
              {otherList && otherList.length > 0 ? (
                <Bar
                  data={{
                    labels: otherList.map((item) => item.period),
                    datasets: [
                      {
                        data: otherList.map((item) => item.total),
                        backgroundColor: (context) => {
                          const index = context.dataIndex;
                          const chart = context.chart;
                          const activeElements = chart.tooltip?.getActiveElements();

                          if (activeElements && activeElements.length > 0) {
                            const hoveredIndex = activeElements[0].index;
                            return hoveredIndex === index ? "#7157C2" : "#E6E1FF";
                          }
                          return "#E6E1FF";
                        },
                        borderRadius: 8,
                        maxBarThickness: 50,
                      },
                    ],
                  }}
                  options={options}
                />
              ) : (
                <div className="text-center text-muted py-3">No data available.</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
